<app-selector label="Jumbles Game" [isEmptySelectable]="isEmptySelectable" [data]="jumbleGameCoreService.jumbleGameList$| async" displayKey="name"
    [formControl]="ctrl" (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="jumbleGameCoreService.loading" [hint]="hint">
</app-selector>